{
  "公司类型": "Company types",
  "新增公司类型": "Add company type",
  "编辑公司类型": "Edit company type",
  "公司类型已删除": "Company type deleted",
  "删除后无法恢复。已被引用的公司类型请使用停用。": "Deletion cannot be undone. Disable company types that are already in use.",
  "该公司类型已被引用，请使用停用": "This company type is in use. Disable it instead.",
  "公司类型代码": "Company type code",
  "公司类型名称": "Company type name",
  "公司类型代码不能使用 all": "The company type code cannot be all",
  "公司类型代码、中文或英文名称": "Company type code, Chinese or English name",
  "公司类型查看": "View company types",
  "公司类型维护": "Manage company types",
  "公司类型编码已存在": "Company type code already exists",
  "公司类型不存在": "Company type not found",
  "该公司类型未开放，请重新选择": "This company type is unavailable. Choose another.",
  "停用后不可新增选用，已有企业资料保留。": "Disabled types cannot be newly selected. Existing company profiles are retained."
}
